exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sitamenue[data-v-79eae869] .v-treeview-node:nth-child(odd){background:#fff}.container[data-v-79eae869]{height:50%}", ""]);

// exports
